/**
 * Rotating placeholders for the home textarea.
 *
 * These are designed to feel less like prompts and more like
 * gentle confessional invitations. Mix of:
 *   • emotionally honest first-person ("i'm tired but not the sleeping kind…")
 *   • soft accusatory questions to the user ("what are you pretending not to feel?")
 *   • interior-monologue fragments ("today felt like an unanswered text…")
 *
 * Order is intentional — heavier prompts later so the first impression is gentle.
 */
export const ROTATING_PLACEHOLDERS = [
    "i'm tired but not the sleeping kind…",
    "today felt like an unanswered text…",
    "say the thing you won't text.",
    "what feeling keeps circling back?",
    "soft. quiet. a little hopeful.",
    "what are you pretending not to feel?",
    "i miss someone i shouldn't miss.",
    "what do you wish someone understood?",
    "i'm proud of myself in a way i can't say out loud.",
    "happy in a complicated way.",
    "everything is fine. and also not.",
    "i think i'm becoming someone i like.",
    "the thing you'd say if no one was reading.",
    "i feel like an early sunday morning.",
    "i'm holding it together with one hand.",
];
